import { cn } from "@/utils";
import type { ComponentPropsWithoutRef } from "react";
import { canvasToolbarDisplayVariants } from "./canvasToolbarStyles";

interface CanvasToolbarDisplayProps extends ComponentPropsWithoutRef<"div"> {}

export function CanvasToolbarDisplay({
  className,
  children,
  ...rest
}: CanvasToolbarDisplayProps) {
  return (
    <div className={cn(canvasToolbarDisplayVariants(), className)} {...rest}>
      {children}
    </div>
  );
}
